/** Model Structure Constructor Factory
    @description See https://stackoverflow.com/a/502384/722785
    @example let options = this.makeStruct([['woot', 'one'], ['snoot', 'two'], ['boot', 'three']]);
    @example console.log('Options', options('a', 'b'), options(null, 'b'));
    @param params Constructor parameters and default values names ie: [['first','john'],['last','smith']]
    @returns Model Constructor
*/
export const makeStruct = (params = []) => {
    /** Structure Constructor */
    const constructor = (...args) => {
        const obj = {};
        for (let i = 0; i < params.length; i++) {
            obj[params[i][0]] = args[i] !== undefined ? args[i] : params[i][1];
        }
        return obj;
    };
    return constructor;
};
